/**
 * Shop the look (RS style): sync hotspot dots with product slider,
 * and handle mobile drawer.
 */
(function () {
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.stlInit === 'true') return;
    sectionEl.dataset.stlInit = 'true';

    const slideshow = sectionEl.querySelector('slide-show');
    const dots = sectionEl.querySelectorAll('.shop-the-look-rs__dot-btn');
    const drawer = sectionEl.querySelector('.shop-the-look-rs__drawer');
    const drawerTrigger = sectionEl.querySelector('.shop-the-look-rs__drawer-trigger');
    const drawerBackdrop = sectionEl.querySelector('.shop-the-look-rs__drawer-backdrop');
    const drawerCloseBtn = sectionEl.querySelector('.shop-the-look-rs__drawer-close');

    function setActiveDot(index) {
      dots.forEach(function (btn, i) {
        if (i === index) {
          btn.classList.add('is-current');
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.classList.remove('is-current');
          btn.removeAttribute('aria-current');
        }
      });
    }

    function goToSlide(index) {
      if (!slideshow || typeof slideshow.setActiveSlide !== 'function') return;
      slideshow.setActiveSlide(parseInt(index, 10));
      setActiveDot(index);
    }

    function getActiveSlideIndex() {
      const activeSlide = sectionEl.querySelector('.slideshow__slide.is-active');
      if (!activeSlide) return 0;
      const idx = activeSlide.getAttribute('data-slide-index');
      return idx !== null ? parseInt(idx, 10) : 0;
    }

    const totalSlides = sectionEl.querySelectorAll('.slideshow__slide').length;

    function updateProgressBar() {
      const fills = sectionEl.querySelectorAll('.shop-the-look-rs__pagination-fill');
      if (fills.length && totalSlides > 0) {
        const progress = totalSlides === 1 ? 1 : (getActiveSlideIndex() + 1) / totalSlides;
        const transform = 'scaleX(' + progress + ')';
        fills.forEach(function (fill) {
          fill.style.transform = transform;
          fill.style.transformOrigin = 'left top';
        });
      }
    }

    if (slideshow) {
      if (dots.length) {
        dots.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const index = btn.getAttribute('data-index');
            if (index !== null) goToSlide(index);
            setTimeout(updateProgressBar, 350);
          });
        });
      }

      /* Event delegation: nav is fixed below slider, listen on section for any nav button click */
      if (slideshow.showNextSlide && slideshow.showPrevSlide) {
        sectionEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.shop-the-look-rs .slideshow-nav button[name]');
          if (!btn) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (btn.name === 'next') {
            slideshow.showNextSlide();
          } else if (btn.name === 'prev') {
            slideshow.showPrevSlide();
          }
          setTimeout(function () {
            if (dots.length) setActiveDot(getActiveSlideIndex());
            updateProgressBar();
          }, 350);
        }, true);
      }

      setTimeout(updateProgressBar, 100);
    }

    if (drawer && drawerTrigger) {
      function openDrawer() {
        drawer.setAttribute('aria-hidden', 'false');
        drawerTrigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.setAttribute('aria-hidden', 'true');
        drawerTrigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      drawerTrigger.addEventListener('click', openDrawer);
      if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
      if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);

      sectionEl.querySelectorAll('[data-close-drawer]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
    }
  }

  function init() {
    document.querySelectorAll('.shop-the-look-rs').forEach(initSection);
  }

  /* Quick buy from this section: move to body so z-index is above header; full-screen modal */
  function closeDrawerModal(qb) {
    if (!qb._stlDrawerRestoreParent || !qb._stlDrawerRestoreBlock) return;
    var parent = qb._stlDrawerRestoreParent;
    var next = qb._stlDrawerRestoreNextSibling;
    parent.insertBefore(qb, next);
    qb._stlDrawerRestoreParent = null;
    qb._stlDrawerRestoreNextSibling = null;
    if (typeof theme !== 'undefined' && theme.quickBuy && theme.quickBuy.contractDetail) {
      theme.quickBuy.contractDetail(qb._stlDrawerRestoreBlock);
    }
    qb._stlDrawerRestoreBlock = null;
  }
  function onQuickbuyBeforeOpen(evt) {
    var qb = evt.target;
    if (!qb || !qb.closest || !qb.closest('.shop-the-look-rs')) return;
    var block = qb.closest('.product-block');
    qb._stlDrawerRestoreBlock = block;
    qb.classList.add('quickbuy--drawer');
    document.body.style.overflow = 'hidden';
    document.body.setAttribute('data-quickbuy-drawer-open', 'true');
    if (block) block.classList.remove('expanded');
    if (qb.parentNode !== document.body) {
      qb._stlDrawerRestoreParent = qb.parentNode;
      qb._stlDrawerRestoreNextSibling = qb.nextSibling;
      document.body.appendChild(qb);
    }
  }
  function onQuickbuyAfterOpen(evt) {
    var qb = evt.target;
    if (!qb || !qb.classList || !qb.classList.contains('quickbuy--drawer')) return;
    var closeBtn = qb.querySelector('.close-detail');
    function handleClose(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      closeDrawerModal(qb);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', handleClose, true);
    }
    qb.addEventListener('click', function backdropClose(ev) {
      if (ev.target === qb) {
        ev.preventDefault();
        ev.stopPropagation();
        qb.removeEventListener('click', backdropClose);
        if (closeBtn) closeBtn.removeEventListener('click', handleClose, true);
        closeDrawerModal(qb);
      }
    }, true);
  }
  function onQuickbuyAfterClose(evt) {
    var qb = evt.target;
    if (!qb) return;
    if (qb._stlDrawerRestoreParent) {
      var parent = qb._stlDrawerRestoreParent;
      var next = qb._stlDrawerRestoreNextSibling;
      if (qb.parentNode === document.body) {
        parent.insertBefore(qb, next);
      }
      qb._stlDrawerRestoreParent = null;
      qb._stlDrawerRestoreNextSibling = null;
    }
    qb._stlDrawerRestoreBlock = null;
    qb.classList.remove('quickbuy--drawer');
    document.body.style.overflow = '';
    document.body.removeAttribute('data-quickbuy-drawer-open');
  }
  document.addEventListener('on:quickbuy:before-open', onQuickbuyBeforeOpen);
  document.addEventListener('on:quickbuy:after-open', onQuickbuyAfterOpen);
  document.addEventListener('on:quickbuy:after-close', onQuickbuyAfterClose);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('.shop-the-look-rs');
    if (section) initSection(section);
  });
})();
